import { useState, useEffect } from "react"
import { navigate } from "vike/client/router"
import PubSub from "pubsub-js"
import PlatformAuth from "aldoo-ra/PlatformAuth"
import Value from "aldoo-ra/Value"
import { url as cmsUrl } from "aldoo-ra/CMS/url"
import { UserIcon } from "@heroicons/react/24/outline"

/// Round account button — avatar/initial when signed in (→ /account),
/// person icon opening the signin dialog otherwise. Mirrors transfer.
export default function AccountButton() {
  const [mounted, setMounted] = useState(false)
  const [auth] = PlatformAuth.useAuth()
  const [profile] = Value("user-profile")

  useEffect(() => setMounted(true), [])
  if (!mounted) return null

  if (auth?.auth_token) {
    const initial = (profile?.name || auth.email || "?").charAt(0).toUpperCase()
    return (
      <button
        onClick={() => navigate("/account")}
        className="w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center text-base font-semibold border border-theme_white hover:bg-primary hover:text-white transition-colors overflow-hidden shrink-0"
        title="Account"
      >
        {profile?.avatar
          ? <img src={cmsUrl(profile.avatar)} alt="" className="w-full h-full object-cover" />
          : initial}
      </button>
    )
  }

  return (
    <button
      onClick={() => PubSub.publish("signin", { redirect: "/account" })}
      className="w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center hover:bg-primary hover:text-white transition-colors shrink-0"
      title="Sign in"
      aria-label="Sign in"
    >
      <UserIcon className="w-5 h-5" />
    </button>
  )
}